import React from 'react';

import mapModifiers from 'utils/functions';

type Sizes = '28x36' | '24x32' | '20x28' | '18x24' | '18x24-2' | '16x19' | '16x22' | '14x20' | '12x18' | '40x48';

export type TextStyle = (GeneralTextStyle | Sizes | ColorStyle)[];

interface TextProps extends React.HtmlHTMLAttributes<HTMLParagraphElement> {
  modifiers?: TextStyle;
  type?: 'p' | 'span' | 'div';
  content?: string;
  children?: React.ReactNode;
}

const Text: React.FC<TextProps> = ({
  modifiers,
  type = 'p',
  content,
  children,
}) => {
  const Element = type;
  return content ? (
    <Element
      className={mapModifiers('a-text', modifiers)}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  ) : (
    <Element className={mapModifiers('a-text', modifiers)}>
      {children}
    </Element>
  );
};

Text.defaultProps = {
  modifiers: undefined,
  content: undefined,
};

export default React.memo(Text);
